module.exports = __webpack_public_path__ + "img/upload.5aa4936e.svg";